import React from 'react';

const Instruction = ({ title, steps}) => {

    return (
        <div style={styles.container}>
            <h3>{title}</h3>
            {steps.map((step, key) => {
                return <div key={key} style={styles.step}>{step.number}. {step.text}</div>
            })}
        </div>
    );
};

export default Instruction;

const styles = {
    container: {
        padding: "20px 0 0 0"
    },
    step: {
        padding: "10px 0"
    }
}